import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchUserProfile } from "../apiService"; // Make sure this is imported

import "../App.css";
import AnnouncementsFloatingWidget from './AnnouncementsFloatingWidget';

const Navbar = ({ handleLoginClick, onLoginStatusChange = () => {} }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState(""); 
  const navigate = useNavigate();
  const feedbackUrl = "https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAN__gLYsZpUREpZWUUzTTBHSDM3SlRNMjlMTzRERzNWMi4u";

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const customerId = localStorage.getItem("portalEndCustomerId");

    if (accessToken && customerId) {
      setIsLoggedIn(true);

      // 👇 Fetch user profile
      fetchUserProfile(customerId)
        .then((profile) => {
          setUserName(profile.firstName); // Or `${profile.firstName} ${profile.lastName}` if full name
        })
        .catch((err) => {
          console.error("Failed to fetch user profile:", err);
        });
    }
  }, []);


  useEffect(() => {
    onLoginStatusChange(isLoggedIn); // Notify parent of login status
  }, [isLoggedIn]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("portalEndCustomerId");
    setIsLoggedIn(false);
    navigate("/");
  };

  return (
    <nav className="navbar navbar-light bg-white sticky-top py-0" >
      <div className="container-fluid px-1">
        <Link className="navbar-brand" to="/">
          <img src="/logo-no-background.png" alt="Logo" />
        </Link>
        <div className="d-flex align-items-center">
          {/* Show announcements widget next to logo only when logged in */}
          {isLoggedIn && (
            <div className="me-3">
              <AnnouncementsFloatingWidget inline={true} maxItems={5} />
            </div>
          )}
  {!isLoggedIn && (
    <>
      {/* Fibre Link */}
      <Link to="/fibre" className="nav-link me-2" style={{ fontSize: "clamp(12px, 2vw, 16px)" }}>
        <i className="bi bi-wifi"></i> Fibre
      </Link>
      {/* Support Link */}
      <Link to="/help" className="nav-link me-2" style={{ fontSize: "clamp(12px, 2vw, 16px)" }}>
        <i className="bi bi-headset"></i> Support
      </Link>
      {/* Contact */}
      <Link to="/contact" className="nav-link me-1" style={{ fontSize: "clamp(12px, 2vw, 16px)" }}>
        <i className="bi bi-telephone"></i> Contact
      </Link>
    </>
  )}
  {isLoggedIn ? (
    <div className="dropdown">
      <button
        className="btn btn-light"
        type="button"
        id="profileDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{
          border: "none",
          background: "none",
          padding: 0,
          color: "#0f174f",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: "bold", marginRight: "0.5rem" }}>{userName}</span> {/* 👈 Name first */}
        <i className="fas fa-user-circle fa-2x" />
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
        <li>
          <Link to="/profile" className="dropdown-item">
            <i className="bi bi-person-circle me-2"></i> Profile
          </Link>
        </li>
        <li>
          <Link to="/manage-subscription" className="dropdown-item">
            <i className="bi bi-box-seam me-2"></i> Subscription
          </Link>
        </li>
        <li>
          <Link to="/fibre" className="dropdown-item">
            <i className="bi bi-wifi me-2"></i> Fibre
          </Link>
        </li>
        <li>
          <Link to="/help" className="dropdown-item">
            <i className="bi bi-headset me-2"></i> Support
          </Link>
        </li>
        <li>
          <Link to="/contact" className="dropdown-item">
            <i className="bi bi-telephone me-2"></i> Contact
          </Link>
        </li>
        <li>
          <Link to="/feedback" className="dropdown-item">
            <i className="bi bi-chat-left-text me-2"></i> Feedback
          </Link>
          {/* <a href={feedbackUrl} target="_blank" rel="noopener noreferrer" className="dropdown-item">
            <i className="bi bi-chat-left-text me-2"></i> Feedback
          </a> */}
        </li>
        <li>
          <Link to="/referral" className="dropdown-item">
            <i className="bi bi-person-plus me-2"></i> Referral
          </Link>
          {/* <a href={feedbackUrl} target="_blank" rel="noopener noreferrer" className="dropdown-item">
            <i className="bi bi-chat-left-text me-2"></i> Feedback
          </a> */}
        </li>
        <li>
          <Link to="/settings" className="dropdown-item">
            <i className="bi bi-gear me-2"></i> Settings
          </Link>
        </li>
        <li>
          <button className="dropdown-item text-danger" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right me-2"></i> Logout
          </button>
        </li>
      </ul>
    </div>
  ) : (
    <button className="btn-theme-orange" onClick={handleLoginClick} style={{ backgroundColor: "#0f174f" }}>
      <i className="fas fa-sign-in-alt"></i> LOGIN
    </button>
  )}
</div>
      </div>
    </nav>
  );
};

export default Navbar;